import BaseService from "../base.service";

const VUE_APP_API_URL = process.env.VUE_APP_API_URL;

class IndexService extends BaseService {
  placeBets(payload: any) {
    return this.post(`${VUE_APP_API_URL}/api/transact`, payload).then(
      ({ data }) => data
    );
  }

  getBetslip(payload: any) {
    return this.post(`${VUE_APP_API_URL}/api/betslip`, payload).then(
      ({ data }) => data
    );
  }
}
export default new IndexService();
